<template>
    <div>
        <h3 class="mb-4">{{ data.title }}</h3>
        <hr>
        <span>{{data.note}}</span>
        <div class="d-flex flex-wrap mb-4">
            <b-table responsive striped hover :items="data.items" :fields="data.fields"
                     thClass="text-center">
            </b-table>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      data: Object,
    },
    data() {
      return {}
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Patient/Print/PatientTabularSection.vue